module.exports = __webpack_public_path__ + "static/img/construction-img.f8dba7cd.png";